import axios from "../../api/axiosInctance";
import { guest } from "../../store/reducers/user/auth";
export const sleep = async (msec = 3000) => {
  return new Promise((resolve) => setTimeout(resolve, msec));
};
//const getToken1 = localStorage.getItem("token");
// export const vehicleDataCall = async (filter) => {
//   try {
//     //console.log(axios);
//     let newFilter = {};
//     Object.keys(filter).map((key) => {
//       if (filter[key] !== null) {
//         newFilter[key] = filter[key];
//       }
//     });
//     // console.log(JSON.stringify(newFilter));
//     const getVehicleData = await axios
//       .get("/vehicle/getVehicles", {
//         params: {
//           pagesize: 1000,
//           filter: JSON.stringify(newFilter),
//         },
//       })
//       .then((res) => {
//         //console.log(res.data);
//         return res.data;
//       })
//       .catch((err) => {
//         console.log("Aldaaa");
//         let message =
//           typeof err.response !== "undefined"
//             ? err.response.data.message
//             : err.message;
//         console.warn("error", message);
//       })
//       .finally(() => {
//         // console.log("ddd");
//       });
//     return getVehicleData;
//   } catch (error) {
//     console.log(error);
//   }
// };
export const vehicleCheckCall = async (data) => {
  try {
    // let newFilter = {};
    // Object.keys(filter).map((key) => {
    //   if (filter[key] !== null) {
    //     newFilter[key] = filter[key];
    //   }
    // });
    // console.log(newFilter);
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const getVehicleListData = await axios
      .post("/vehicle/check", data)
      .then((res) => {
        //  console.log(res);
        if (res.data.status.code === 200) {
          return res.data;
        }
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getVehicleListData;
  } catch (error) {
    console.log(error);
  }
};
export const vehicleServiceTypeCall = async (data) => {
  try {
    // let newFilter = {};
    // Object.keys(filter).map((key) => {
    //   if (filter[key] !== null) {
    //     newFilter[key] = filter[key];
    //   }
    // });
    // console.log(newFilter);
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const getVehicleListData = await axios
      .post("/vehicle/service_type/list", data)
      .then((res) => {
        //  console.log(res);
        if (res.data.status.code === 200) {
          return res.data;
        }
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getVehicleListData;
  } catch (error) {
    console.log(error);
  }
};
export const vehicleDataCall = async (filter) => {
  try {
    let newFilter = {};
    Object.keys(filter).map((key) => {
      if (filter[key] !== null) {
        newFilter[key] = filter[key];
      }
    });
    //console.log(newFilter);
    const getVehicleListData = await axios
      .post("/company/vehicle/list", newFilter)
      .then((res) => {
        //  console.log(res);
        if (res.data.status.code === 200) {
          return res.data;
        }
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getVehicleListData;
  } catch (error) {
    console.log(error);
  }
};
export const vehicleRemoveService = async (data) => {
  try {
    //  console.log(axios);

    // console.log(JSON.stringify(newFilter));
    const removeVeh = await axios
      .post("/company/vehicle/delete", data)
      .then((res) => {
        //console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return removeVeh;
  } catch (error) {
    console.log(error);
  }
};

export const editVehicleService = async (formData) => {
  try {
    //   console.log(plateNo);

    const getInspection = await axios
      .post("/company/vehicle/edit", formData)
      .then((res) => {
        //  console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getInspection;
  } catch (error) {
    console.log(error);
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
export const inspectionCall = async ({ plate_no }) => {
  try {
    //console.log(axios);

    const getInspection = await axios
      .post("/vehicle/inspection", plate_no)
      .then((res) => {
        //  console.log(res.data);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getInspection;
  } catch (error) {
    console.log(error);
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
export const vehicleSearchCall = async ({ plateNo }) => {
  try {
    //console.log(axios);

    const getInspection = await axios
      .post("vehicle/data", plateNo)
      .then((res) => {
        // console.log("=--==========");
        //  console.log(res);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getInspection;
  } catch (error) {
    console.log(error);
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
export const getVehicleTypeListCall = async () => {
  try {
    //console.log(axios);

    const getResponse = await axios
      .post("vehicle/service_type/list")
      .then((res) => {
        // console.log("=--==========");
        // console.log(res);
        return res.data;
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined" ? err.response.data : err.message;
        //  console.log(message.status.message);
        const data = {
          status: { code: 400, message: message.status.message },
        };
        return data;
      })
      .finally(() => {
        // console.log("ddd");
      });
    return getResponse;
  } catch (error) {
    console.log(error);
  }

  // console.log(ddd);
  //const guestToken = localStorage.getItem("guestToken");
  // return guestToken;
};
